import React from "react";

const CouponPreview = ({ coupon }) => {

    if (!coupon) return null;

    return (
        <div className="coupon-preview">

            <h2>{coupon.code}</h2>

            <h3>{coupon.title}</h3>

            <p>{coupon.description}</p>

            <div className="preview-discount">

                {coupon.discountType === "percentage"
                    ? `${coupon.discountValue}% OFF`
                    : `₹${coupon.discountValue} OFF`}

            </div>

            <p>
                Minimum Order ₹{coupon.minOrderAmount}
            </p>

            <p>
                Maximum Discount ₹{coupon.maxDiscount}
            </p>

            <button disabled>
                Apply Coupon
            </button>

        </div>
    );
};

export default CouponPreview;